import { Box } from '@material-ui/core';
import { FC } from 'react';
import ActionButton from 'components/MyInfo/ActionButton/ActionButton';

export const ActionButtons: FC<{ onDelete?: VoidFunction; onEdit?: VoidFunction; isDisabled: boolean }> = ({
  onDelete,
  onEdit,
  isDisabled,
}) => (
  <Box
    style={{
      opacity: isDisabled ? 0.6 : 'unset',
      pointerEvents: isDisabled ? 'none' : 'unset',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    }}
  >
    <ActionButton onDelete={onDelete} onEdit={onEdit} />
  </Box>
);
